import React from 'react'
import PropTypes from 'prop-types'

import TextParagraph from './Text'
import ChartParagraph from './Chart'
import DataTableParagraph from './DataTable'
import ImageParagraph from './Image'
import H5pParagraph from './H5p'
import HtmlParagraph from './Html'
import LinkParagraph from './Link'
import ConnectionParagraph from './Connection'
import VideoParagraph from './Video'
import QuoteParagraph from './Quote'
import GalleryParagraph from './Gallery'
import UndefinedParagraph from './Undefined'
import SectionParagraph from './Section'
import QuestionsBucketParagraph from './QuestionsBucket'
import TeacherDivisor from './../TeacherDivisor'
import DocumentParagraph from './Document'

import styles from './Paragraph.module.css'

const paragraphTypes = {
  text: TextParagraph,
  image: ImageParagraph,
  h5p: H5pParagraph,
  html: HtmlParagraph,
  link: LinkParagraph,
  connection: ConnectionParagraph,
  video: VideoParagraph,
  quote: QuoteParagraph,
  gallery: GalleryParagraph,
  und: UndefinedParagraph,
  chart: ChartParagraph,
  data_table: DataTableParagraph,
  node_section: SectionParagraph,
  questions_bucket: QuestionsBucketParagraph,
  document: DocumentParagraph,
}

const ParagraphExtras = ({ id, value, type, styleWidth }) => (
  <div
    id={id}
    style={{ width: styleWidth && styleWidth + 'px' }}
    className={styles[`paragraph-${type}`]}
    dangerouslySetInnerHTML={{ __html: value }}
  />
)

const Paragraph = ({ entity, headerTeacher, footerTeacher, noHeaderNoFooter }) => {
  const ParagraphContent = paragraphTypes[entity.type]

  return (
    <>
      {headerTeacher && entity.avaliableTeacherOnly && <TeacherDivisor />}
      {noHeaderNoFooter && <div className={styles.noHeaderNoFooter} />}
      {paragraphTypes[entity.type] && (
        <div
          className={`${styles.paragraph} ${`paragraph-${entity.type}`} ${
            entity.avaliableTeacherOnly ? styles.teacherbackground : ''
          }`}
        >
          {entity.description && (
            <ParagraphExtras type='description' value={entity.description.value} />
          )}

          <div className={styles[`paragraph-content`]}>
            <ParagraphContent {...entity} />
          </div>

          {entity.caption && (
            <div className={styles.captionWidth}>
              <ParagraphExtras
                type='caption'
                id={
                  entity.media && entity.media.entity && entity.media.entity.image
                    ? 'caption-image-media-' + entity.media.entity.mid
                    : null
                }
                value={entity.caption.value}
                styleWidth={
                  entity.media && entity.media.entity && entity.media.entity.image
                    ? entity.media.entity.image.width
                    : ''
                }
              />
            </div>
          )}
        </div>
      )}
      {footerTeacher && entity.avaliableTeacherOnly && (
        <hr className={`${styles.rounded} ${styles.teacherdivisorend}`} />
      )}
      {noHeaderNoFooter && <div className={styles.noHeaderNoFooter} />}
    </>
  )
}

ParagraphExtras.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  styleWidth: PropTypes.number,
}

Paragraph.propTypes = {
  entity: PropTypes.object,

  headerTeacher: PropTypes.bool,
  footerTeacher: PropTypes.bool,
}

export default Paragraph
